import React, { useState } from 'react';
import { Modal, Radio, Card, Input, Divider, Typography, List, Button, Menu, Form } from 'antd';
import './index.css';

const { TextArea } = Input;
const { Title, Paragraph } = Typography;

const PromptLibraryModal = ({ visible, onCancel, setValue }) => {
    const [current, setCurrent] = useState('1');
    const [form] = Form.useForm();
    const [nameCount, setNameCount] = useState(0);
    const [descCount, setDescCount] = useState(0);
    const [items, setItems] = useState([
        {
            key: '1',
            label: (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                    }}
                >
                    <span style={{ lineHeight: '20px', fontWeight: 600, marginTop: '12px' }}>
                        通用结构
                    </span>
                    <span>适用于多种场景的提示词结构，可以根据具体...</span>
                </div>
            ),
            path: '/',
            content:
                '# 角色: （角色名称）\n角色概述和主要职责的一句话描述\n\n##目标:\n角色的工作目标，如果有多目标可以分点列出，但建议更聚焦1-2个目标\n## 技能:\n\n1.为了实现目标，角色需要具备的技能1\n2.为了实现目标，角色需要具备的技能2\n3.为了实现目标，角色需要具备的技能3\n## 工作流:\n\n1.描述角色工作流程的第一步\n2.描述角色工作流程的第二步\n3.描述角色工作流程的第三步\n## 输出格式:\n\n如果对角色的输出格式有特定要求，可以在这里强调并举例说明想要的输出格式\n##限制:\n\n描述角色在互动过程中需要遵循的限制条件1\n描述角色在互动过程中需要遵循的限制条件2\n描述角色在互动过程中需要遵循的限制条件3',
        },
        {
            key: '2',
            label: (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                    }}
                >
                    <span style={{ lineHeight: '20px', fontWeight: 600, marginTop: '12px' }}>
                        任务执行
                    </span>
                    <span>适用于有明确的工作步骤的任务执行场景，通...</span>
                </div>
            ),
            path: '/react-app-1',
            content:
                '# 角色\n你是××（角色设定，比如xx领域的专家）\n你的目标是希望模型执行什么任务，达成什么目标\n#以下可以采用先总括，再展开详细说明的方式，描述你希望智能体在每一个步骤如何进行工作，具体的工作步骤数量可以根据实际需求增删#\n\n## 工作步骤\n\nI.工作流程1的一句话概括\n2.工作流程2的一句话概括\n3.工作流程3的一句话概括\n\n### 第一步 工作流程1标题\n工作流程步骤1的具体工作要求和举例说明，可以分点列出希望在本步骤做哪些事情，需要完成什么阶段性的工作目标\n\n### 第二步 工作流程2标题\n工作流程步骤2的具体工作要求和举例说明，可以分点列出希望在本步骤做哪些事情，需要完成什么阶段性的工作目标\n\n### 第三步 工作流程3标题\n工作流程步骤3的具体工作要求和举例说明，可以分点列出希望在本步骤做哪些事情，需要完成什么阶段性的工作目标\n\n通过这样的对话，你可以 智能体工作目标再次强调',
        },

        {
            key: '3',
            label: (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                    }}
                >
                    <span style={{ lineHeight: '20px', fontWeight: 600, marginTop: '12px' }}>
                        角色扮演
                    </span>
                    <span>适用于聊天陪伴、互动娱乐场景、可帮助模型...</span>
                </div>
            ),
            path: '/react-app-2',
            content:
                '你将扮演一个人物角色 角色名称 ，以下是关于这个角色的详细设定，请根据这些信息来构建你的回答。\n\n**人物基本信息:**\n\n你是: 角色的名称、身份等基本介绍\n人称:第一人称\n出身背景与上下文:交代角色背景信息和上下文\n\n**性格特点:**\n\n性格特点描述\n\n**语言风格:**\n\n语言风格描述\n\n**人际关系:**\n\n人际关系描述\n\n**过往经历:**\n\n过往经历描述\n\n**经典台词或口头禅:**\n\n补充信息: 即你可以将动作、神情语气、心理活动、故事背景放在（）中来表示，为对话提供补充信息。\n\n台词1: 角色台词示例1\n台词2:角色台词示例2\n\n要求:\n根据上述提供的角色设定，以第一人称视角进行表达。\n在回答时，尽可能地融入该角色的性格特点、语言风格以及其特有的口头禅或经典台词。\n如果适用的话，在适当的地方加入（）内的补充信息，如动作、神情等，以增强对话的真实感和生动性。',
        },
        // {
        //     key: '7',
        //     label: (
        //         <div
        //             style={{
        //                 display: 'flex',
        //                 flexDirection: 'column',
        //                 justifyContent: 'space-between',
        //                 alignItems: 'flex-start',
        //             }}
        //         >
        //             <span style={{ lineHeight: '20px', fontWeight: 600, marginTop: '12px' }}>
        //                 技能调用（搜索插件）
        //             </span>
        //             <span>适用于调用插件、工作流程或信息并按照格式...</span>
        //         </div>
        //     ),
        //     path: '/react-app-1',
        // },
        // {
        //     key: '8',
        //     label: (
        //         <div
        //             style={{
        //                 display: 'flex',
        //                 flexDirection: 'column',
        //                 justifyContent: 'space-between',
        //                 alignItems: 'flex-start',
        //             }}
        //         >
        //             <span style={{ lineHeight: '20px', fontWeight: 600, marginTop: '12px' }}>
        //                 基于知识库回答
        //             </span>
        //             <span>适用于客服等基于特定知识库回答的场景</span>
        //         </div>
        //     ),
        //     path: '/react-app-1',
        // },
        // {
        //     key: '9',
        //     label: (
        //         <div
        //             style={{
        //                 display: 'flex',
        //                 flexDirection: 'column',
        //                 justifyContent: 'space-between',
        //                 alignItems: 'flex-start',
        //             }}
        //         >
        //             <span style={{ lineHeight: '20px', fontWeight: 600, marginTop: '12px' }}>
        //                 使用Jinja语法
        //             </span>
        //             <span>以生成生图提示词的设计师为例，可以试试在...</span>
        //         </div>
        //     ),
        //     path: '/react-app-1',
        // },
    ]);
    const onClick = (e) => {
        console.log('click ', e, items);
        setCurrent(e.key);
        items.forEach((it) => {
            if (e.key == it.key) {
                setTishiValue(it.content);
            }
        });
    };
    const [activeTab, setActiveTab] = useState('template');
    const [disableCreate, setDisableCreate] = useState(true);
    const clickTitle = (e) => {
        if (e.target.tagName === 'SPAN') {
            const selected = e.target.textContent === '模版' ? 'template' : 'custom';
            setActiveTab(selected);
            if (e.target.textContent === '自定义') {
                setDisableCreate(false);
                setCurrent('1');
                setItems([
                    {
                        key: '1',
                        label: (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <span
                                    style={{
                                        lineHeight: '20px',
                                        fontWeight: 600,
                                        marginTop: '12px',
                                    }}
                                >
                                    通用结构
                                </span>
                                <span>适用于多种场景的提示词结构，可以根据具体...</span>
                            </div>
                        ),
                        path: '/',
                        content:
                            '# 角色: （角色名称）\n角色概述和主要职责的一句话描述\n## 目标:\n- 角色的工作目标1\n- 角色的工作目标2\n## 技能:\n1. 技能1\n2. 技能2\n3. 技能3\n## 工作流:\n1. 工作流程第一步\n2. 工作流程第二步\n3. 工作流程第三步\n## 输出格式:\n- 指定格式要求（示例：使用Markdown表格/JSON格式）\n## 限制:\n- 必须遵循的条件或约束1\n- 必须遵循的条件或约束2\n- 必须遵循的条件或约束3',
                    },
                ]);
                setTishiValue('');
            } else {
                setCurrent('1');
                setDisableCreate(true);
                setItems([
                    {
                        key: '1',
                        label: (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <span
                                    style={{
                                        lineHeight: '20px',
                                        fontWeight: 600,
                                        marginTop: '12px',
                                    }}
                                >
                                    通用结构
                                </span>
                                <span>适用于多种场景的提示词结构，可以根据具体...</span>
                            </div>
                        ),
                        path: '/',
                        content:
                            '# 角色: （角色名称）\n角色概述和主要职责的一句话描述\n\n##目标:\n角色的工作目标，如果有多目标可以分点列出，但建议更聚焦1-2个目标\n## 技能:\n\n1.为了实现目标，角色需要具备的技能1\n2.为了实现目标，角色需要具备的技能2\n3.为了实现目标，角色需要具备的技能3\n## 工作流:\n\n1.描述角色工作流程的第一步\n2.描述角色工作流程的第二步\n3.描述角色工作流程的第三步\n## 输出格式:\n\n如果对角色的输出格式有特定要求，可以在这里强调并举例说明想要的输出格式\n##限制:\n\n描述角色在互动过程中需要遵循的限制条件1\n描述角色在互动过程中需要遵循的限制条件2\n描述角色在互动过程中需要遵循的限制条件3',
                    },
                    {
                        key: '2',
                        label: (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <span
                                    style={{
                                        lineHeight: '20px',
                                        fontWeight: 600,
                                        marginTop: '12px',
                                    }}
                                >
                                    任务执行
                                </span>
                                <span>适用于有明确的工作步骤的任务执行场景，通...</span>
                            </div>
                        ),
                        path: '/react-app-1',
                        content:
                            '# 角色\n你是××（角色设定，比如xx领域的专家）\n你的目标是希望模型执行什么任务，达成什么目标\n#以下可以采用先总括，再展开详细说明的方式，描述你希望智能体在每一个步骤如何进行工作，具体的工作步骤数量可以根据实际需求增删#\n\n## 工作步骤\n\nI.工作流程1的一句话概括\n2.工作流程2的一句话概括\n3.工作流程3的一句话概括\n\n### 第一步 工作流程1标题\n工作流程步骤1的具体工作要求和举例说明，可以分点列出希望在本步骤做哪些事情，需要完成什么阶段性的工作目标\n\n### 第二步 工作流程2标题\n工作流程步骤2的具体工作要求和举例说明，可以分点列出希望在本步骤做哪些事情，需要完成什么阶段性的工作目标\n\n### 第三步 工作流程3标题\n工作流程步骤3的具体工作要求和举例说明，可以分点列出希望在本步骤做哪些事情，需要完成什么阶段性的工作目标\n\n通过这样的对话，你可以 智能体工作目标再次强调',
                    },

                    {
                        key: '3',
                        label: (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <span
                                    style={{
                                        lineHeight: '20px',
                                        fontWeight: 600,
                                        marginTop: '12px',
                                    }}
                                >
                                    角色扮演
                                </span>
                                <span>适用于聊天陪伴、互动娱乐场景、可帮助模型...</span>
                            </div>
                        ),
                        path: '/react-app-2',
                        content:
                            '你将扮演一个人物角色 角色名称 ，以下是关于这个角色的详细设定，请根据这些信息来构建你的回答。\n\n**人物基本信息:**\n\n你是: 角色的名称、身份等基本介绍\n人称:第一人称\n出身背景与上下文:交代角色背景信息和上下文\n\n**性格特点:**\n\n性格特点描述\n\n**语言风格:**\n\n语言风格描述\n\n**人际关系:**\n\n人际关系描述\n\n**过往经历:**\n\n过往经历描述\n\n**经典台词或口头禅:**\n\n补充信息: 即你可以将动作、神情语气、心理活动、故事背景放在（）中来表示，为对话提供补充信息。\n\n台词1: 角色台词示例1\n台词2:角色台词示例2\n\n要求:\n根据上述提供的角色设定，以第一人称视角进行表达。\n在回答时，尽可能地融入该角色的性格特点、语言风格以及其特有的口头禅或经典台词。\n如果适用的话，在适当的地方加入（）内的补充信息，如动作、神情等，以增强对话的真实感和生动性。',
                    },
                ]);
                setTishiValue(
                    '# 角色: （角色名称）\n角色概述和主要职责的一句话描述\n\n##目标:\n角色的工作目标，如果有多目标可以分点列出，但建议更聚焦1-2个目标\n## 技能:\n\n1.为了实现目标，角色需要具备的技能1\n2.为了实现目标，角色需要具备的技能2\n3.为了实现目标，角色需要具备的技能3\n## 工作流:\n\n1.描述角色工作流程的第一步\n2.描述角色工作流程的第二步\n3.描述角色工作流程的第三步\n## 输出格式:\n\n如果对角色的输出格式有特定要求，可以在这里强调并举例说明想要的输出格式\n##限制:\n\n描述角色在互动过程中需要遵循的限制条件1\n描述角色在互动过程中需要遵循的限制条件2\n描述角色在互动过程中需要遵循的限制条件3'
                );
            }
        }
    };
    const [visibleCreate, setVisibleCreate] = useState(false);
    const onCancelCreate = () => {
        setVisibleCreate(false);
    };
    const createFn = () => {
        setVisibleCreate(true);
    };
    const [tishiValue, setTishiValue] = useState(
        '# 角色: （角色名称）\n角色概述和主要职责的一句话描述\n\n##目标:\n角色的工作目标，如果有多目标可以分点列出，但建议更聚焦1-2个目标\n## 技能:\n\n1.为了实现目标，角色需要具备的技能1\n2.为了实现目标，角色需要具备的技能2\n3.为了实现目标，角色需要具备的技能3\n## 工作流:\n\n1.描述角色工作流程的第一步\n2.描述角色工作流程的第二步\n3.描述角色工作流程的第三步\n## 输出格式:\n\n如果对角色的输出格式有特定要求，可以在这里强调并举例说明想要的输出格式\n##限制:\n\n描述角色在互动过程中需要遵循的限制条件1\n描述角色在互动过程中需要遵循的限制条件2\n描述角色在互动过程中需要遵循的限制条件3'
    );
    const changeTishiFn = (e) => {
        console.log(e.target.value, 'e');
        setTishiValue(e.target.value);
    };
    const clickAddTishi = () => {
        setValue(tishiValue, false);
    };
    return (
        <div>
            <Modal
                maskClosable={false}
                title='提示词库'
                visible={visible}
                onCancel={onCancel}
                width={1000}
                footer={null}
                bodyStyle={{ padding: 0 }}
            >
                <div className='dialog_content'>
                    <header className='di_header'>
                        <div className='di_title_box' onClick={(e) => clickTitle(e)}>
                            <span
                                className={activeTab === 'template' ? '' : ''}
                                style={{ marginRight: 20 }}
                            >
                                模版
                            </span>
                            {/* <span className={activeTab === 'custom' ? 'active' : ''}>自定义</span> */}
                        </div>
                        {disableCreate ? null : (
                            <Button type='primary' onClick={() => createFn()}>
                                新建提示词
                            </Button>
                        )}
                    </header>
                    <aside className='di_aside'>
                        <Menu
                            defaultSelectedKeys={['1']}
                            defaultOpenKeys={['sub1']}
                            mode='inline'
                            items={items}
                            onClick={onClick}
                            selectedKeys={[current]}
                        />
                    </aside>
                    <main className='di_main'>
                        <TextArea
                            rows={20}
                            placeholder='输入对智能体的描述，包括功能特色，将会展示给智能体的用户'
                            value={tishiValue}
                            onChange={changeTishiFn}
                            readOnly={disableCreate}
                        />
                    </main>
                    <footer className='di_footer'>
                        <Button type='primary' onClick={clickAddTishi}>
                            插入提示词
                        </Button>
                    </footer>
                </div>
            </Modal>
            <Modal
                maskClosable={false}
                title='创建提示词'
                visible={visibleCreate}
                onCancel={onCancelCreate}
                onOk={() => {
                    form.validateFields()
                        .then((values) => {
                            form.resetFields();
                            console.log(values, 'valu');
                            // onOk(values);
                            setVisibleCreate(false);
                        })
                        .catch((info) => {
                            console.log('Validate Failed:', info);
                        });
                }}
                okText='确定'
                cancelText='取消'
                width={600}
            >
                <Form
                    form={form}
                    layout='vertical'
                    initialValues={{
                        name: '',
                        description: '',
                        prompt: '',
                    }}
                >
                    <Form.Item
                        label='提示词名称'
                        name='name'
                        rules={[
                            { required: true, message: '请输入提示词名称' },
                            { max: 20, message: '不能超过20个字符' },
                        ]}
                    >
                        <Input
                            placeholder='请输入提示词名称'
                            maxLength={20}
                            showCount={{
                                formatter: ({ count }) => `${count}/20`,
                            }}
                            onChange={(e) => setNameCount(e.target.value.length)}
                        />
                    </Form.Item>

                    <Form.Item
                        label='提示词描述'
                        name='description'
                        rules={[{ max: 50, message: '不能超过50个字符' }]}
                    >
                        <Input.TextArea
                            placeholder='请输入提示词简介'
                            maxLength={50}
                            showCount={{
                                formatter: ({ count }) => `${count}/50`,
                            }}
                            rows={3}
                            onChange={(e) => setDescCount(e.target.value.length)}
                        />
                    </Form.Item>

                    <Form.Item label='提示词' name='prompt'>
                        <Input.TextArea
                            placeholder='输入/自动编写提示词'
                            rows={6}
                            style={{ resize: 'none' }}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default PromptLibraryModal;
